<tbody>
    {{#each comparePlansContent}}
    <tr>
        <td colspan="4" {{#if custom_class}}class="{{custom_class}}"{{/if}}>{{content_table_title}}{{#if new_tag}}<span class="badge beta">NEW</span>{{/if}} {{#if beta_tag}}<span class="badge beta">BETA</span>{{/if}}</td>
    </tr>
        {{#each content_table_rows}}
            
                <tr>
                    <td scope="row">
                        <div class="row-heading">
                            <span>{{row_heading}} {{#if new_tag}}<span class="badge beta">NEW</span>{{/if}}</span>
                            
                            <img class="question" src="/assets/img/icons/info-mark.png" alt="" data-toggle="tooltip" data-placement="bottom" data-offset="70" title="" data-original-title="{{info}}">
                        </div>
                    </td>
                    {{!-- Loops contain same content since partials are being problematic. Change in one, change in all others --}}
                    {{#if world_values}}
                        {{#if ../../is_world_content}}
                            {{#each world_values}}
                                {{#if text}}
                                    <td>{{content}}</td>
                                {{else}}
                                    {{#if content}}
                                    <td><img src="/assets/img/icons/teal_tick.svg" alt=""></td>
                                    {{else}}
                                    <td><img src="/assets/img/icons/grey_cross.svg" alt=""></td>
                                    {{/if}}
                                {{/if}}
                            {{/each}}
                        {{else}}
                            {{#each values}}
                                {{#if text}}
                                    <td>{{content}}</td>
                                {{else}}
                                    {{#if content}}
                                    <td><img src="/assets/img/icons/teal_tick.svg" alt=""></td>
                                    {{else}}
                                    <td><img src="/assets/img/icons/grey_cross.svg" alt=""></td>
                                    {{/if}}
                                {{/if}}
                            {{/each}}
                        {{/if}}
                    {{else}}
                        {{#each values}}
                            {{#if text}}
                                <td>{{content}}</td>
                            {{else}}
                                {{#if content}}
                                <td><img src="/assets/img/icons/teal_tick.svg" alt=""></td>
                                {{else}}
                                <td><img src="/assets/img/icons/grey_cross.svg" alt=""></td>
                                {{/if}}
                            {{/if}}
                        {{/each}}
                    {{/if}}
                </tr>
            
                

        {{/each}}
    <tr class="blank"></tr>
    {{/each}}
</tbody>